import React from 'react';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services/ifys-services' },
  { label: 'Child & Family Services' },
];

const ChildFamilyServicesPage = () => {
  return (
    <PageLayout activeLink="services">
      <PageHero
        title="Child and Family Services"
        backgroundImage="/images/service-headers/child_family_services%201.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6">
          Child and Family Services
        </h2>
      </section>

      {/* Partners In Action */}
      <section className="bg-gray-50 border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <h3 className="text-2xl sm:text-3xl font-bold text-ifys-blue mb-6">Partners In Action</h3>
          <div className="space-y-4 text-gray-700 text-base sm:text-lg leading-relaxed">
            <p>
              Partners In Action (PIA) are responsible for collaboration and partnerships that seek
              to strengthen service system integration to improve community and sector based
              responses to domestic and family violence. The team raise community awareness and are
              available to provide education sessions, consultations and professional development
              opportunities for community members and sector providers.
            </p>
          </div>
          <div className="mt-6 p-5 bg-white rounded-2xl border border-gray-200 shadow-sm">
            <p className="text-sm text-gray-700 leading-relaxed">
              For more information about Partners In Action, visit our website{' '}
              <a href="https://sunshinecoastdfvcoordination.com.au" target="_blank" rel="noopener noreferrer" className="text-ifys-blue font-semibold hover:underline">
                sunshinecoastdfvcoordination.com.au
              </a>{' '}
              or contact IFYS on{' '}
              <a href="tel:0754383000" className="text-ifys-blue font-semibold hover:underline">07 5438 3000</a>{' '}
              and ask to speak with Domestic and Family Violence Team for more information.
            </p>
          </div>
        </div>
      </section>

      {/* Assessment and Service Connect */}
      <section>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <h3 className="text-2xl sm:text-3xl font-bold text-ifys-blue mb-6">
            Assessment and Services Connect
          </h3>
          <div className="space-y-4 text-gray-700 text-base sm:text-lg leading-relaxed">
            <p>
              IFYS&rsquo;s Assessment and Service Connect (ASC) Program seeks to increase the safety
              of children, young people and families, ensuring children are cared for, protected and
              able to reach their full potential.
            </p>
            <p>
              ASC receives referrals only from the Department responsible for Child Safety, in
              relation to families who have come to the attention of the Department due to reports of
              harm, or alleged risk of harm, where there is a current open investigation. ASC aims to
              connect referred families with the right support services, at the right time and in the
              right place. ASC is a voluntary service, supporting children, young people and their
              families to identify goals that increase their safety, sense of belonging, and overall
              wellbeing. Where cultural needs are identified, ASC can assist with connection to
              culture and appropriate services.
            </p>
            <p>
              IFYS provides an ASC co-responses in the Child Safety catchment areas of the Sunshine
              Coast, Moreton Bay and Cairns and Surrounds.
            </p>
          </div>
          <div className="mt-6 p-5 bg-white rounded-2xl border border-gray-200 shadow-sm">
            <p className="text-sm text-gray-700 leading-relaxed">
              Contact{' '}
              <a href="tel:0754383000" className="text-ifys-blue font-semibold hover:underline">07 5438 3000</a>{' '}
              if you require any information about our Assessment and Service Connect programs.
            </p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default ChildFamilyServicesPage;
